// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3R7R6","content":"ManualTimeModal_content__3aGum"};